import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      'Language Settings': 'Language Settings',
      'Select Language': 'Select Language',
      'English language interface': 'English language interface',
      'Bahasa Indonesia': 'Bahasa Indonesia',
      'Antarmuka bahasa Indonesia': 'Indonesian language interface',
      'Language Information': 'Language Information',
      'Language changes are applied immediately': 'Language changes are applied immediately',
      'Your language preference is saved locally': 'Your language preference is saved locally',
      'All interface elements will be translated': 'All interface elements will be translated',
    },
  },
  id: {
    translation: {
      'Language Settings': 'Pengaturan Bahasa',
      'Select Language': 'Pilih Bahasa',
      'English language interface': 'Antarmuka bahasa Inggris',
      'Bahasa Indonesia': 'Bahasa Indonesia',
      'Antarmuka bahasa Indonesia': 'Antarmuka bahasa Indonesia',
      'Language Information': 'Informasi Bahasa',
      'Language changes are applied immediately': 'Perubahan bahasa diterapkan segera',
      'Your language preference is saved locally': 'Preferensi bahasa Anda disimpan secara lokal',
      'All interface elements will be translated': 'Semua elemen antarmuka akan diterjemahkan',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('appLanguage') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 